import {getChecklist, setChecklist} from "./progress"

function render(root) {
  const boxes = Array.from(root.querySelectorAll("[data-learn-item]"))
  const done = boxes.filter((box) => box.checked).length
  const total = boxes.length
  const count = root.querySelector("[data-learn-check-count]")
  if (count) count.textContent = String(done)
  const bar = root.querySelector("[data-learn-check-bar]")
  if (bar) bar.style.transform = `scaleX(${total ? done / total : 0})`
  const cheer = root.querySelector("[data-learn-check-done]")
  if (cheer) cheer.hidden = done !== total || total === 0
}

export function mount(root) {
  const saved = getChecklist()
  root.querySelectorAll("[data-learn-item]").forEach((box) => {
    if (saved[box.dataset.learnItem]) box.checked = true
    box.addEventListener("change", () => {
      setChecklist(box.dataset.learnItem, box.checked)
      render(root)
    })
  })
  render(root)
}
